import { combineReducers } from 'redux';

import userReducer, { key as userKey } from 'component/user/reducer';

import { IStore } from './types/reducers';

export default combineReducers<IStore>({
    [userKey]: userReducer
});
